import React, { useState, useEffect } from 'react';
import BodySmall from '../Text/BodySmall';
import Accordion from '../Accordion';
import DropUpArrow from '../Icons/DropUpArrow';
import DropDownArrow from '../Icons/DropDownArrow';
import { useRouter } from '../../../hooks/useCustomRouter';
import { Price } from 'ui/interface';
import generateFilterAccessories from '../../../helpers/utils/generateFilterAccessories';

import { useSearchParams } from 'next/navigation';
import { IFilterOptions, IValueFilter } from '../../../interface/accessories.interface';

interface FilterModalContentProps {
  minPrice: Price;
  maxPrice: Price;
  slideMin: number;
  slideMax: number;
  specialOffer?: IFilterOptions;
  typeID?: string;
  setTriggerFilter?: any;
  pickUpOption?: IFilterOptions;
  typeAccFilter?: IFilterOptions;
  categoryFilter?: IFilterOptions;
  carModel?: IFilterOptions;
  isPLPCategory?: boolean;
}

export default function FilterModalContentAccessories({
  minPrice,
  maxPrice,
  slideMin,
  slideMax,
  specialOffer,
  typeID,
  setTriggerFilter,
  pickUpOption,
  typeAccFilter,
  categoryFilter,
  carModel,
  isPLPCategory,
}: FilterModalContentProps) {
  const baseUrl = process.env.NEXT_PUBLIC_URL;

  const router = useRouter();
  const searchParams = useSearchParams();
  const filters = generateFilterAccessories(
    minPrice,
    maxPrice,
    slideMin,
    slideMax,
    specialOffer,
    typeID,
    setTriggerFilter,
    pickUpOption,
    typeAccFilter,
    categoryFilter,
    carModel,
    isPLPCategory
  );
  const [filter, setFilter] = useState([]);
  const category = typeID === 'accessories' ? `/${router.query.carModel}` : '';

  useEffect(() => {
    const existingQueryParams = searchParams.get('q');
    const convertSlugToNormal = (val: IValueFilter[]) => {
      return val
        ?.filter((item) => existingQueryParams?.replaceAll('+', ' ')?.includes(item?.code))
        ?.map((item) => item?.code);
    };
    const filteringOffers = convertSlugToNormal(specialOffer?.values);
    const filteringCarModel = convertSlugToNormal(carModel?.values);
    const filteringCategory = convertSlugToNormal(categoryFilter?.values);
    const filteringTypeAcc = convertSlugToNormal(typeAccFilter?.values);
    const filteringPickUp = convertSlugToNormal(pickUpOption?.values);

    setFilter([
      ...(filteringCarModel || []),
      ...(filteringOffers || []),
      ...(filteringPickUp || []),
      ...(filteringCategory || []),
      ...(filteringTypeAcc || []),
    ]);
  }, [searchParams]);
  const priceFilter = searchParams.get('priceFilter');
  const defaultMin = searchParams.get('defaultMin');
  const defaultMax = searchParams.get('defaultMax');

  const handleResetFilter = () => {
    router.push(
      `${router?.query?.city ? baseUrl + '/c/aksesoris' + category + '?city=' + router?.query?.city : baseUrl + '/c/aksesoris' + category}`
    );
    setFilter([]);
  };

  const handleDeleteCarModel = (
    value: string,
    selectedValues: string[],
    setSelectedValues: (argv: string[]) => void,
    options: IValueFilter[]
  ) => {
    const removeFuelFromList = selectedValues.filter((item) => item !== value);
    setSelectedValues(removeFuelFromList);

    const selectedFuelListValueTrue = options?.filter((item) => item.selected === true);
    const getValueByName = selectedFuelListValueTrue.filter(
      (item) => item?.code.toUpperCase() === value.toUpperCase()
    )?.[0];

    const newUrl = `${new URLSearchParams(
      getValueByName?.query?.query.value ? getValueByName?.query?.query.value : ''
    )
      .toString()
      .replace(/%3AbodyType%3A\w+/gi, '')}`;

    router.push(
      newUrl
        ? `${baseUrl}/c/aksesoris?q=${newUrl.replace('=', '')}${
            priceFilter
              ? `&priceFilter=${priceFilter}&defaultMin=${defaultMin}&defaultMax=${defaultMax}`
              : ''
          }`
        : ''
    );
  };

  return (
    <div className="text-reliableBlack w-full">
      {filter?.length > 0 && (
        <div className="flex justify-between mb-2 px-4 mt-4">
          <div className="flex flex-wrap flex-1 gap-2">
            {/* {filter?.length > 0 && ( */}
            <div className="flex  flex-wrap gap-2 mb-2">
              {filter?.map((value, index) => {
                return (
                  <div
                    key={index}
                    className="flex items-center border gap-2 px-2 py-1 bg-reliableBlack10 rounded-full"
                  >
                    <BodySmall className="text-xs">{value}</BodySmall>
                    <BodySmall
                      className="text-[#918F8F] text-xs cursor-pointer"
                      onClick={() =>
                        handleDeleteCarModel(value, filter, setFilter, [
                          ...(pickUpOption?.values || []),
                          ...(specialOffer?.values || []),
                          ...(typeAccFilter?.values || []),
                          ...(categoryFilter?.values || []),
                          ...(carModel?.values || []),
                        ])
                      }
                    >
                      x
                    </BodySmall>
                  </div>
                );
              })}
            </div>
            {/* )} */}
          </div>
          <div className="flex justify-end mt-1.5 cursor-pointer" onClick={handleResetFilter}>
            <BodySmall className="text-xs font-bold text-supportiveRed">Reset Filter</BodySmall>
          </div>
        </div>
      )}

      {filters.map((filter, index) => {
        if (filter.content) {
          return (
            <Accordion
              key={index}
              classNameSummary={
                '-my-[18px] py-[18px] text-sm text-start font-medium text-reliableBlack cursor-pointer lg:text-base'
              }
              classTitleWrapper={
                'w-full flex justify-between items-center px-4 lg:px-0 font-semibold text-[16px] text-[#231F20]'
              }
              classNameChildrenWrapper={
                'text-start text-sm font-normal text-reliableBlack leading-relaxed lg:text-base lg:leading-relaxed px-4 lg:px-0'
              }
              index={index.toString()}
              title={filter.title}
              activeIcon={<DropUpArrow />}
              inactiveIcon={<DropDownArrow />}
            >
              {filter.content}
            </Accordion>
          );
        }
      })}
    </div>
  );
}
